module.exports = __webpack_public_path__ + "media/lays.94508d4f.mp4";